import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import InCardTextFieldWrapper from 'hcla-web-frontend-primitives/app/components/primitives/TextField/InCardTextFieldWrapper';

const Samples = (props) => {
  const { selected, invalid, onUpdate } = props;
  return (
    <Tooltip title="Number of data points to sample from">
      <InCardTextFieldWrapper>
        <TextField
          onChange={e => onUpdate(e, e.target.value)}
          defaultValue={selected}
          label="Samples"
          margin="dense"
          error={invalid}
          type="number"
          id="samples"
        />
      </InCardTextFieldWrapper>
    </Tooltip>
  );
};

Samples.defaultProps = {
  selected: 30000,
};

Samples.propTypes = {
  selected: PropTypes.number,
  invalid: PropTypes.bool.isRequired,
  onUpdate: PropTypes.instanceOf(Function).isRequired,
};

export default Samples;
